import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_right",
  "use": "icon-mine_right-usage",
  "viewBox": "0 0 15 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 26\" id=\"icon-mine_right\"><path fill=\"#CCC\" d=\"M.112 2.374 2.334 0l12.11 12.94L2.222 26 0 23.626 10 12.94z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol